import { seguroConfigService } from "@/_services";

export const seguroConfig = {
  namespaced: true,
  state: {
    entity: {
      data: {},
      status: {},
    },
    update: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getError(state, error) {
      state.entity.data = {};
      state.entity.status = {
        error,
      };
    },
    getSuccess(state, data) {
      state.entity.data = data;
      state.entity.status = {
        loaded: true,
      };
    },
    updateRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updateError(state, error) {
      state.update.data = {};
      state.update.status = {
        error,
      };
    },
    updateSuccess(state, data) {
      state.update.data = data;
      state.update.status = {
        updated: true,
      };
    },
  },
  actions: {
    get({ commit }) {
      commit("getRequest");
      seguroConfigService
        .get()
        .then((res) => {
          commit("getSuccess", res);
        })
        .catch((error) => {
          commit("getError", error);
        });
    },
    update({ commit }, req) {
      commit("updateRequest");
      seguroConfigService
        .update(req)
        .then((res) => {
          commit("updateSuccess", res);
        })
        .catch((error) => {
          commit("updateError", error);
        });
    },
  },
};
